//The order of imports is very important. date-fns *must* be before luxon
import "chartjs-adapter-date-fns";
import "chartjs-adapter-luxon";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip, LineController,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";

export function RegisterChartComponent() {
  Chart.register(
    ArcElement,
    Title,
    Tooltip,
    Legend,
    BarElement,
    LineController,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    TimeScale,
    annotationPlugin,
  );
}
